export const platformVersion = '^18.1.1';
